import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["onChange", "onBlur", "checked"],
    _excluded2 = ["error", "touched"],
    _excluded3 = ["setValue", "setTouched"];
import { useCallback } from 'react';
import { useField } from 'formik';
export var useExtendedField = function useExtendedField(formikConfig) {
  var extend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onChangeOverride = extend.onChange,
      errorTextOverride = extend.errorText,
      modifyValue = extend.modifyValue,
      _extend$showValidatio = extend.showValidationErrorOnChange,
      showValidationErrorOnChange = _extend$showValidatio === void 0 ? false : _extend$showValidatio;

  var _useField = useField(formikConfig),
      _useField2 = _slicedToArray(_useField, 3),
      _useField2$ = _useField2[0],
      formikOnChange = _useField2$.onChange,
      formikOnBlur = _useField2$.onBlur,
      checked = _useField2$.checked,
      fieldRest = _objectWithoutProperties(_useField2$, _excluded),
      _useField2$2 = _useField2[1],
      error = _useField2$2.error,
      touched = _useField2$2.touched,
      metaRest = _objectWithoutProperties(_useField2$2, _excluded2),
      _useField2$3 = _useField2[2],
      setValue = _useField2$3.setValue,
      setTouched = _useField2$3.setTouched,
      helperRest = _objectWithoutProperties(_useField2$3, _excluded3);

  var onChange = useCallback(function (e) {
    switch (formikConfig.type) {
      case 'checkbox':
        formikOnChange(e);
        if (onChangeOverride) onChangeOverride(e);
        break;

      case 'radio':
        formikOnChange(e);
        if (onChangeOverride) onChangeOverride(e);
        break;

      default:
        if (onChangeOverride) onChangeOverride(e);

        if (modifyValue) {
          setValue(modifyValue(e.target.value));
        } else setValue(e.target.value);

    }

    if (formikConfig.type !== 'select') setTouched(showValidationErrorOnChange);
  }, [setTouched, showValidationErrorOnChange, formikConfig.type, formikOnChange, onChangeOverride, modifyValue, setValue]);
  var onBlur = useCallback(function (e) {
    formikOnBlur(e);
    setTouched(true);
  }, [formikOnBlur, setTouched]);
  return [_extends({
    type: formikConfig.type,
    onChange: onChange,
    onBlur: onBlur,
    checked: formikConfig.type === 'checkbox' ? checked : undefined
  }, fieldRest), _extends({
    errorText: errorTextOverride || (touched ? error : ''),
    error: error,
    touched: touched
  }, metaRest), _extends({
    setValue: setValue,
    setTouched: setTouched
  }, helperRest)];
};